
<template>
  <div>
      <div v-show="showVue" style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   欠税票
                </span>
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
              
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-9">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                 <div class="col-lg-5">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        供应商编号或名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                    <input type="text" class="form-control font heit" v-model="searchForm.supplierNum" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                             
                                 </div>
                                   
                             </div>
                               
                          </div>
                       </div>
                        <div class="col-lg-3">
                          <div class="row ml-lg-3">            
                                 <button class="bg-primary button_zi heit" @click="getClerkStoreGoodsQuery()">查询</button>
                               
                      </div>
                  </div>
                </div>    

            <table v-if="showPage" class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>流水号</th>
                        <th>供应商</th>
                        <th>供应商编号</th>
                        <th>单据数</th>
                        <th>金额</th>
                        <th>操作日期</th>
                        <th>状态</th>
                        <th>备注</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.num}}</td>
                              <td class="jz_middle">{{item.supplierName}}</td>
                              <td class="jz_middle">{{item.supplierNum}}</td>
                              <td class="jz_middle">{{item.orderCount}}</td>
                              <td class="jz_middle">{{item.totalPrice}}</td>
                              <td class="jz_middle">{{item.createDate | formatUTC}}</td>
                              <td class="jz_middle" style="color:green;">{{item.state | state}}</td>
                              <td class="jz_middle">{{item.remark}}</td>
                              <td class="jz_middle">
                                  <button class="bg-primary button_zi heit" @click="getDetails(index)">
                                      详情
                                  </button>
                              </td>
                      </tr>
                    </tbody>
                  </table>

                  <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->
                     <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content" style="width:1200px;position:relative;top:50px;left:-150px;margin-bottom:50px;">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                     <div class="card">
                                                    <table class="table table-striped table-hover">
                                                        <thead>
                                                            <tr style="white-space: nowrap;">
                                                                <th>购进单号</th>
                                                                <th>品种名称</th>
                                                                <th>品种编号</th>
                                                                <th>厂家</th>
                                                                <th>规格</th>
                                                                <th>包装</th>
                                                                <th>批号</th>
                                                                <th>批号个数</th>
                                                                <th>数量</th>
                                                                <th>进价</th>
                                                                <th>金额</th>
                                                                <th>状态</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <tr v-for="(item,index) in details" :key="index">
                                                                 <td class="jz_middle">{{item.orderNum}}</td>
                                                                 <td class="jz_middle">
                                                                   {{item.drugName}}
                                                                  </td>
                                                                 <td class="jz_middle">
                                                                    {{item.drugNum}}
                                                                 </td>
                                                                 <td>{{item.factroy}}</td>
                                                                 <td>{{item.specification}}</td>
                                                                 <td>{{item.pack}}</td>
                                                                 <td>{{item.batchNum}}</td>
                                                                 <td>{{item.batchsCount}}</td>
                                                                 <td>{{item.counts}}</td>
                                                                 <td>{{item.purchPrice}}</td>
                                                                 <td>{{item.money}}</td>
                                                                 <td class="jz_middle" style="color:red;">{{item.status | status}}</td>
                                                             </tr>
                                                        </tbody>
                                                    </table>
                                    <!-- 分页 -->
                                     </div>
                               </div>
                            <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                            </div>
                            </div>
                        </div>
                    </div>

  
                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import Loading from '../../components/Loading.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          supplierNum:"",
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        excelData:[],
        showPage:true,
        details:[],
        totalPurchMoney:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
            showVue:false,

      }
    },
    components:{
        vPagination,
        Loading
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
        lin:function(data){
            if(data==1){
              return "零"
            }
            else{
               return "整"
            }
        },
        rate:function(rate){
              if(rate==1){
                   return "不打折"
              }
              else{
                  return "打"+rate*10+"折";
              }
        },
        state:function(state){
            if(state==1)
            {
              return "欠税额"
            }
            else if(state==2){
              return "欠全款"
            }
            else if(state==3){
               return "停止办款"
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        }
},

methods: {

    getDetails(index){
        
        this.details = this.tableData[index].details;
        console.log(this.details)
        $("#myModal").modal();
    
    },

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
       //导出方法
       //导出查询页 默认全部查询
                exportExcel() {
                const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","产地名称","库区","规格","单位","单价","零/整","包装","批号","数量","有效期","入账日期","打折情况","返利情况"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['drugName', 'productFactory', 'storeNo','spec','unit','price','isRetail','pack','batchNum','storeNum','dueDate','inAccountDate','disCountRate','isPromotion']; // 上面的index、nickName、name是tableData里对象的属性key值
                      await that.getExcelData()
                      const list = that.excelData
                     const data = that.formatJson(filterVal, list);
                     export_json_to_excel(tHeader, data, '库存查询');//最后一个是表名字
                })
              },
          //导出当前页
              exportExcel1() {
                require.ensure([], () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","产地名称","库区","规格","单位","单价","零/整","包装","批号","数量","有效期","入账日期","打折情况","返利情况"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['drugName', 'productFactory', 'storeNo','spec','unit','price','isRetail','pack','batchNum','storeNum','dueDate','inAccountDate','disCountRate','isPromotion']; // 上面的index、nickName、name是tableData里对象的属性key值
                  if(this.searchData.length>0){
                    const list = this.searchData;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '库存查询');//最后一个是表名字
                  }
                  else{
                     const list = this.tableData;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '库存查询');//最后一个是表名字
                  }
                })
              },
              formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
              },
      

  
      getClerkStoreGoodsQuery: async function (PageIndex) {
          // this.isLoading=true;
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkOweInvoice',
          obj: JSON.stringify({
             PageIndex,
             SupplierName:this.searchForm.supplierNum.trim(),
          }) 
        })
        // console.log(res)
           if(res.isok){
               this.showVue=true;
                const obj=res.data
                this.tableData = obj.rows
                if(this.tableData.length>0)
                {
                    this.showPage=true;
                }
                else{
                    this.showPage =false;
                }
                // this.total = obj.record
                // this.Pcount = obj.pcount
                // this.Record = obj.record
                // this.totalPurchMoney=obj.totalPurchMoney
                // this.isLoading=false
           }
         
         
      },
      getExcelData: async function () {
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkStoreGoodsQuery',
          obj: JSON.stringify({
             PageIndex:1,
             PageSize:50000,
             SearchType:1,
             DrugName: this.searchForm.ypmc.trim(),
            BatchNum: this.searchForm.ph.trim(),
            ProductFactory: this.searchForm.cdmc.trim(),
            Spec: this.searchForm.gg.trim()
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.excelData = obj.rows
        
        }
      },
     
    start_print(){
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
    }

    },
     mounted(){
    },
     created () {

        this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
</style>



// WEBPACK FOOTER //
// src/pages/Tax/OutStandingTax.vue